import React from 'react'

import { FieldInstructionBundle, FieldKit } from '../../index'
import FieldBuilder from '../FieldBuilder/FieldBuilder'

interface FieldGroupProps {
    fieldInstructionBundle: FieldInstructionBundle
    fieldKit?: FieldKit
}

function FieldGroup(props: FieldGroupProps) {
    const { fieldInstructionBundle, fieldKit } = props
    const fieldNames = Object.keys(fieldInstructionBundle)

    const elements = fieldNames.map((fieldName) => {
        const inputConfig = fieldInstructionBundle[fieldName]

        return (
            <FieldBuilder
                key={fieldName}
                fieldName={fieldName}
                fieldInstructionAny={inputConfig}
                fieldKit={fieldKit}
            />
        )
    })

    return <>{elements}</>
}

export default FieldGroup

FieldGroup.defaultProps = {
    fieldKit: undefined,
}
